import { EXPIRE_PACKAGE } from '../constants/ActionTypes';

export default function expirePackage(item_id, descrip) {
  return {
    type: EXPIRE_PACKAGE,
    item_id,
    descrip
  };
}
